
$(function () {
    $('.heatmap .table-list .table-heatmap').each(function () {
        const $table = $(this).find('table');
        $table.removeAttr('style');
        $table.find('tr').each(function () {
            $(this).removeAttr('style');
            $(this).find('td').each(function (index) {
                $(this).removeAttr('style');
                if(index !== 0) {
                    const classSpan = $(this).html();
                    // console.log($('<span>').addClass(classSpan));
                    $(this).html($('<div>').addClass(classSpan).html($('<span>')));
                }
    
            });
        });

        const title = $('<h5>').html($(this).find('h5').html());
        
        setTimeout(() => {            
            $(this).find('h5').replaceWith(function(){
                return $('<div>').addClass('title-heatmap').html(title).outerWidth($table.outerHeight());
            });
        }, 1000);
    });

    $('body').on('click', '.tabs-header', function () {
        $('.heatmap .table-list .table-heatmap').each(function () {
            const $table = $(this).find('table');
            $(this).find('.title-heatmap').outerWidth($table.outerHeight())            
        });
    });

    $(window).on("resize", function (event) {
        $('.heatmap .table-list .table-heatmap').each(function () {
            const $table = $(this).find('table');
            $(this).find('.title-heatmap').outerWidth($table.outerHeight())            
        });
    });


    $(window).on("scroll", function (event) {
        const initTopPosition= $('section.heatmap').offset().top;   
        const initBottomPosition= $('section.heatmap').outerHeight() + initTopPosition;   
        // console.log(initTopPosition, $(window).scrollTop(), initBottomPosition);
        // console.log(); 
        if($(window).scrollTop() > initTopPosition && $(window).scrollTop() < initBottomPosition) {
            $('section.heatmap').find('.tabs-header').css({'position':'sticky','top':'0px'}).addClass('shadow');
            $('header').removeClass('fixed');
        }
        else {
            if($(window).scrollTop() > initBottomPosition) {
                $('section.heatmap').find('.tabs-header').css({'position':'absolute', 'top': $('section.heatmap').outerHeight() + 'px'}).removeClass('shadow');
            } else {
                $('section.heatmap').find('.tabs-header').css({'position':'relative'}).removeClass('shadow');
            }
            $('header').addClass('fixed');
        }
    });
});

